import request from '@/utils/request'

export const getUserInfo = (data: any) =>
  request({
    url: 'edu/users/info',
    method: 'post',
    data
  })
export const getClueNumber = () =>
  request({
    url: '/edu/notHandleClue',
    method: 'get'
  })

export const getFeedbackNumber = () =>
  request({
    url: '/edu/notHandleFeedback',
    method: 'get'
  })

export const deleteFeedback = (data: any) =>
  request({
    url: '/edu/applets/feedback',
    method: 'delete',
    data
  })
export const login = (data: any) =>
  request({
    url: '/edu/login',
    method: 'post',
    data
  })
export const getCode = (data: any) =>
  request({
    url: '/edu/phone/code',
    method: 'post',
    data
  })
export const logout = () =>
  request({
    url: '/users/logout',
    method: 'post'
  })

export const instrumentType = () =>
  request({
    url: '/edu/instrumentType',
    method: 'get'
  })
export const teacher = () =>
  request({
    url: '/edu/teacher',
    method: 'get'
  })
export const campus = () =>
  request({
    url: '/edu/campus',
    method: 'get'
  })
export const business = (business_type, data_type, instrument_type, campus_id, teacher_id, start_time, end_time) =>
  request({
    url: `/edu/dashboard/business?business_type=${business_type}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}`,
    method: 'get'
  })
export const teaching = (data_type, instrument_type, campus_id, teacher_id, start_time, end_time) =>
  request({
    url: `/edu/dashboard/Teaching?data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}`,
    method: 'get'
  })
export const dashboardIndex = (data_type, instrument_type, campus_id, teacher_id, start_time, end_time) =>
  request({
    url: `/edu/dashboard/index?data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}`,
    method: 'get'
  })
export const teachingRatio = (data_type, instrument_type, campus_id, teacher_id, start_time, end_time, is_avg) =>
  request({
    url: `/edu/dashboard/teachingRatio?data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&is_avg=${is_avg}`,
    method: 'get'
  })
export const studentIndex = (data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages) =>
  request({
    url: `/edu/dashboard/student/index?data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}`,
    method: 'get'
  })
export const courseType = () =>
  request({
    url: '/edu/courseType',
    method: 'get'
  })
export const studentLevels = () =>
  request({
    url: '/edu/studentLevel',
    method: 'get'
  })
export const customerSource = () =>
  request({
    url: '/edu/customerSource',
    method: 'get'
  })
export const userHistory = () =>
  request({
    url: '/edu/userHistory',
    method: 'get'
  })
export const getInstrument = (org_id) =>
  request({
    url: `/edu/instrumentType?org_id=${org_id}`,
    method: 'get'
  })
export const getCampus = (types, org_id) =>
  request({
    url: `/edu/employee?types=${types}&org_id=${org_id}`,
    method: 'get'
  })
export const getCourse = (org_id, campusId, teacherEmployeeId, instrumentTypeId, startTime, hidden_data) =>
  request({
    url: `/edu/course?campus_id=${campusId}&org_id=${org_id}&teacher_employee_id=${teacherEmployeeId}&instrument_type_id=${instrumentTypeId}&start_time=${startTime}&hidden_data=${hidden_data}`,
    method: 'get'
  })
export const campusClassroom = (org_id, campus_id) =>
  request({
    url: `/edu/campusClassroom?campus_id=${campus_id}&org_id=${org_id}`,
    method: 'get'
  })
export const student = (org_id, name) =>
  request({
    url: `/edu/student?name=${name}&org_id=${org_id}`,
    method: 'get'
  })
export const lessStudent = (org_id, name, is_less) =>
  request({
    url: `/edu/student?name=${name}&org_id=${org_id}&is_less=${is_less}`,
    method: 'get'
  })
export const studentIsCourse = (org_id, name, is_course) =>
  request({
    url: `/edu/student?name=${name}&org_id=${org_id}&is_course=${is_course}`,
    method: 'get'
  })
export const curriculum = (data) =>
  request({
    url: `/edu/course`,
    method: 'post',
    data
  })
export const editCourse = (data) =>
  request({
    url: `/edu/course`,
    method: 'put',
    data
  })
export const deleteCourse = (data) =>
  request({
    url: `/edu/course`,
    method: 'delete',
    data
  })
  export const getReserveStudent = (data) =>
    request({
        url: `/edu/courseSign/reserve`,
        method: 'put',
        data
    })
export const getCustomer = (name, phone, org_id) =>
  request({
    url: `/edu/customer?phone=${phone}&name=${name}&org_id=${org_id}`,
    method: 'get'
  })
export const getNowCustomer = (name, customer_id, phone, org_id) =>
  request({
    url: `/edu/customer?phone=${phone}&search_customer_id=${customer_id}&name=${name}&org_id=${org_id}`,
    method: 'get'
  })
export const getBaseCourse = (org_id, campus_id) =>
  request({
    url: `/edu/baseCourse?org_id=${org_id}&campus_id=${campus_id}`,
    method: 'get'
  })
export const courseLevel = (org_id) =>
  request({
    url: `/edu/courseLevel?org_id=${org_id}`,
    method: 'get'
  })
export const material = (org_id, teacherEmployeeId, student_id) =>
  request({
    url: `/edu/material?teacherEmployeeId=${teacherEmployeeId}&org_id=${org_id}&student_id=${student_id}`,
    method: 'get'
  })
export const courseSign = (org_id, course_id) =>
  request({
    url: `/edu/courseSign?course_id=${course_id}&org_id=${org_id}`,
    method: 'get'
  })
export const getEditAudition = (org_id, course_id, types) =>
  request({
    url: `/edu/course?course_id=${course_id}&types=${types}&org_id=${org_id}`,
    method: 'get'
  })
export const getClassSign = (data) =>
  request({
    url: `/edu/courseSign`,
    method: 'post',
    data
  })
export const getCourseSignLists = (org_id, course_id, student_id, types) =>
  request({
    url: `/edu/courseSign?org_id=${org_id}&course_id=${course_id}&student_id=${student_id}&types=${types}`,
    method: 'get'
  })
export const studentLevel = (org_id) =>
  request({
    url: `/edu/studentLevel?org_id=${org_id}`,
    method: 'get'
  })
export const dashboardStudent = (data_type, instrument_type, campus_id, teacher_id, start_time, end_time) =>
  request({
    url: `/edu/dashboard/student?data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}`,
    method: 'get'
  })
export const campusDetails = (campus_id) =>
  request({
    url: `/edu/campus?campus_id=${campus_id}`,
    method: 'get'
  })
export const addCampusClassroom = (data) =>
  request({
    url: `/edu/campusClassroom`,
    method: 'post',
    data
  })
export const editCampusClassroom = (data) =>
  request({
    url: `/edu/campusClassroom`,
    method: 'put',
    data
  })
export const deleteCampusClassroom = (id) =>
  request({
    url: `/edu/campusClassroom?id=${id}`,
    method: 'delete'
  })
export const saleList = (is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/sale?is_total=${is_total}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const orderList = (is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/order?is_total=${is_total}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const marketList = (is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/market?is_total=${is_total}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const customerList = (is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/customerService?is_total=${is_total}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const teachList = (is_total, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/teachData?is_total=${is_total}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const yearSale = (field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/yearSale?field_name=${field_name}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const saleDetailList = (field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size) =>
  request({
    url: `/edu/dashboard2/list/sale?field_name=${field_name}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}&page=${page}&size=${size}`,
    method: 'get'
  })
export const marketDetailList = (field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size) =>
  request({
    url: `/edu/dashboard2/list/market?field_name=${field_name}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}&page=${page}&size=${size}`,
    method: 'get'
  })
export const customerDetailList = (field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size) =>
  request({
    url: `/edu/dashboard2/list/customerService?field_name=${field_name}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}&page=${page}&size=${size}`,
    method: 'get'
  })
export const orderDetailList = (field_name, data_type, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source, page, size) =>
  request({
    url: `/edu/dashboard2/list/order?field_name=${field_name}&data_type=${data_type}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}&page=${page}&size=${size}`,
    method: 'get'
  })
export const yearOrder = (field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/yearOrder?field_name=${field_name}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const yearMarket = (field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/yearMarket?field_name=${field_name}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const yearTeachData = (field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/yearTeachData?field_name=${field_name}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const yearCustomer = (field_name, instrument_type, campus_id, teacher_id, start_time, end_time, ages, source) =>
  request({
    url: `/edu/dashboard2/yearCustomerService?field_name=${field_name}&instrument_type=${instrument_type}&campus_id=${campus_id}&teacher_id=${teacher_id}&start_time=${start_time}&end_time=${end_time}&ages=${ages}&source=${source}`,
    method: 'get'
  })
export const teachCourseList = (campus_id, teacher_id, instrument_type, course_type_id, course_type, course_level_id, sale_employee_id, start_time, end_time, page, size, is_work) =>
  request({
    url: `/edu/courseList?campus_id=${campus_id}&teacher_id=${teacher_id}&instrument_type=${instrument_type}&course_type_id=${course_type_id}&course_type=${course_type}&course_level_id=${course_level_id}&sale_employee_id=${sale_employee_id}&start_time=${start_time}&end_time=${end_time}&page=${page}&size=${size}&is_work=${is_work}`,
    method: 'get'
  })
